<template>
    <div class="file-preview-container" v-loading="loading"
         element-loading-text="文件加载中..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(255, 255, 255, 1)"
    >
        <div class="office-box" v-if="isOnline && (isDocx || isXlsx || isPpt)">
            <iframe
                :src="`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(officeUrl)}`"
                width="100%"
                height="100%"
                frameborder="0"
                @load="onLoaded"
            ></iframe>
        </div>
        <div
            class="offline-vue-office w-full h-full"
            v-if="!isOnline && (isDocx || isPpt || isXlsx)"
        >
            <el-scrollbar style="height: 100%" v-if="isDocx || isPdf">
                <vue-office-docx
                    v-if="isDocx"
                    :src="url"
                    :key="url"
                    @rendered="onLoaded"
                    style="height: 100%; width: 100%"
                />
            </el-scrollbar>
            <vue-office-pptx
                v-if="isPpt"
                :src="url"
                :key="url"
                @rendered="onLoaded"
                style="height: 100%; width: 100%"
            />
            <vue-office-excel
                v-if="isXlsx && !isOnline"
                class="w-full h-full"
                :key="url"
                :src="url"
                @rendered="onLoaded"
            />
        </div>
        <vue-office-pdf v-if="isPdf" :key="url" :src="url" @rendered="onLoaded" class="w-full h-full" />
        <div class="video-box" v-if="isVideo">
            <video
                ref="player"
                id="player"
                :autoplay="true"
                :controls="true"
                :key="url"
                fluid
                @loadeddata="onLoaded"
            >
                <source
                    :src="url"
                    type="video/mp4"
                    data-setup='{"fluid": true, "aspectRatio": "16:9"}'
                />
            </video>
        </div>
        <div v-if="(isRar || isZip)">
            <iframe :src="url" width="100%" height="100%" frameborder="0"></iframe>
        </div>
    </div>
</template>
<script>
import VueOfficePdf from '@vue-office/pdf'
import VueOfficeDocx from '@vue-office/docx'
import VueOfficeExcel from '@vue-office/excel'
import VueOfficePptx from '@vue-office/pptx'
import '@vue-office/excel/lib/index.css'
import '@vue-office/docx/lib/index.css'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import { Loading } from 'element-ui'
import Vue from 'vue'
import { previewUrl } from '@/utils/upload/useOss'
export default {
    name: 'FilePreview',
    props: {
        url: {
            type: String,
            required: true
        }
    },
    components: {
        VueOfficePdf,
        VueOfficeDocx,
        VueOfficeExcel,
        VueOfficePptx
    },
    data() {
        return {
            loading: false,
            isOnline:
                process.env.NODE_ENV === 'development'
                    ? true
                    : !/\d+\.\d+\.\d+\.\d+/.test(location.host),
            officeUrl: "",

        }
    },
    computed: {
        isVideo() {
            const videoExts = ['.mp4']
            return this.fileExtension(videoExts)
        },
        isPdf() {
            return this.fileExtension(['.pdf'])
        },
        isDocx() {
            return this.fileExtension(['.docx'])
        },
        isXlsx() {
            return this.fileExtension(['.xlsx'])
        },
        isPpt() {
            return this.fileExtension(['.pptx'])
        },
        isRar() {
            return this.fileExtension(['.rar'])
        },
        isZip() {
            return this.fileExtension(['.zip'])
        }
    },
    watch: {
        url(newVal, oldVal) {
            this.loadingInit()
        }
    },
    methods: {
        async loadingInit() {
            if (this.isRar || this.isZip) {
                this.loading = false
            } else {
                this.loading = true
            }
            this.officeUrl = await previewUrl(this.url)
            //     Loading.service({
            //     lock: true,
            //     text: '文件加载中',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(255, 255, 255)'
            // })
        },
        onLoaded() {
            this.loading = false
            // &&
            //     Vue.nextTick(() => {
            //         this.loading.close()
            //     })
        },
        fileExtension(extensions) {
            if (!this.url) return ''
            const fileUrl = this.url.split('?')[0]
            const ext = fileUrl.substring(fileUrl.lastIndexOf('.')).toLowerCase()
            return extensions.includes(ext)
        },
        closeLoading() {
            this.loading = false
        }
    },
    mounted() {
        this.loadingInit()
        console.log("url", this.url)
    },
    beforeDestroy() {
        this.closeLoading()
    }
}
</script>
<style lang="scss" scoped>
.video-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
}
#player {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
}
.w-full {
    width: 100%;
}
.h-full {
    height: 100%;
}
.file-preview-container {
    width: 100%;
    height: 100%;
    &,
    & * {
        box-sizing: border-box;
    }
    .office-box {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        iframe {
            position: absolute;
            top: -88px;
            height: calc(100% + 88px);
        }
    }
    .offline-vue-office {
        background: gray;
    }
}
</style>
